export class ShippingItem {
    constructor(
        public IdCliente:string,
        public CaseNumber:string,
        public InteractionNumber:string,
        public Address1: string,
        public Address2: string,
        public Address3:string,
        public City: string,
        public State:string,
        public Country:string,
        public PostalCode:string,
        public FirstName:string, 
        public LastName:string,
        public EmailAddress:string,
        public PhoneNumber:string,
        public SessionId: string,
        public DealerCode: string,
        public CompanyCode: string
    ){

    }
}
